<template>
    <b-row class="justify-content-center">
        <div class="d-flex justify-content-between mb-3">
            <div>
                <b-button class="mx-1 " variant="primary" :disabled="loadCSV"  @click.prevent="$emit('exportCSV')"><i class="fa fa-cloud-download" v-if="!loadCSV"></i>
                    <b-spinner small v-if="loadCSV"></b-spinner>
                    Exportar CSV
                </b-button>
                <b-button class="mx-1" variant="secondary" @click="$emit('voltar')"><i class="fa fa-reply"></i> Voltar</b-button>
            </div>
        </div>
    </b-row>
</template>

<script>
export default {
    props: ['loadCSV']
}
</script>
